<app-lms-modal-frame [title]="'Branch Statistics Report'" [pageHeadWidth]="500">
  <div modal-body class="p-0">
    <section class="stats-section">

      <!-- ── Stats table ── -->
      <div class="stats-table-panel">
        <div class="stats-scroll-wrapper">
          <table class="stats-table" #table>
            <caption class="stats-caption">Statistics by selected dates</caption>
            <thead class="stats-thead">
              <tr>
                <th scope="col">Loan status</th>
                <th scope="col" class="stats-count-col">Count</th>
              </tr>
            </thead>
            <tbody>
             <tr *ngFor="let stats of statsList" class="stats-row stats-row--{{getStatusRowClass(stats.loanStatus)}}">
                <td data-label="Loan status" class="stats-status-cell">
                  <span class="status-dot status-dot--{{getStatusRowClass(stats.loanStatus)}}"></span>
                  {{stats.loanStatus}}
                </td>
                <td data-label="Count" class="stats-count-cell">{{stats.loanCount}}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

    </section>
  </div>

  <div modal-actions class="action-bar">
    <button class="btn-action btn-close-modal" type="button" (click)="close()">Close</button>
  </div>
</app-lms-modal-frame>
